(function() { window.GUID_9001a5e0_fc12_4122_9e85_9ffaee097aac = { getGuid: function() { return "9001a5e0-fc12-4122-9e85-9ffaee097aac"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PremiumLockedOverlayLockIconVariant;
        (function (PremiumLockedOverlayLockIconVariant) {
            PremiumLockedOverlayLockIconVariant[PremiumLockedOverlayLockIconVariant["Small_Centered"] = 0] = "Small_Centered";
            PremiumLockedOverlayLockIconVariant[PremiumLockedOverlayLockIconVariant["Small_TopRight"] = 1] = "Small_TopRight";
            PremiumLockedOverlayLockIconVariant[PremiumLockedOverlayLockIconVariant["Small_TopLeft"] = 2] = "Small_TopLeft";
            PremiumLockedOverlayLockIconVariant[PremiumLockedOverlayLockIconVariant["Medium_Centered"] = 3] = "Medium_Centered";
            PremiumLockedOverlayLockIconVariant[PremiumLockedOverlayLockIconVariant["Large_Centered"] = 4] = "Large_Centered";
            PremiumLockedOverlayLockIconVariant[PremiumLockedOverlayLockIconVariant["None"] = 5] = "None";
        })(PremiumLockedOverlayLockIconVariant = Enumeration.PremiumLockedOverlayLockIconVariant || (Enumeration.PremiumLockedOverlayLockIconVariant = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PremiumLockedOverlayLockIconVariant.pre.js.map
